import React from "react";
import styled from "styled-components";


export default styled.div`
    position: absolute;
    background: white;
    border: 1px solid rgb(195 196 197);
    font-size: 12px;
    right: 20px;
    box-shadow: 2px 2px 20px #0000001a;
    display: ${(props) => (props.hidden ? "none" : "inline-block")};
`;
